import React from 'react';
import { Check } from 'lucide-react';

interface CheckboxProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type'> {
  label?: string;
}

export const Checkbox = React.forwardRef<HTMLInputElement, CheckboxProps>(
  ({ label, className = '', checked, defaultChecked, onChange, disabled, ...props }, ref) => {
    const [isChecked, setIsChecked] = React.useState(defaultChecked || false);
    const controlled = checked !== undefined;
    const activeChecked = controlled ? checked : isChecked;

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      if (!controlled) {
        setIsChecked(e.target.checked);
      }
      if (onChange) {
        onChange(e);
      }
    };

    return (
      <label className={`inline-flex items-center gap-2 cursor-pointer select-none group ${disabled ? 'opacity-50 cursor-not-allowed' : ''}`}>
        <div className="relative flex items-center justify-center">
          <input
            type="checkbox"
            ref={ref}
            checked={controlled ? checked : undefined}
            defaultChecked={!controlled ? defaultChecked : undefined}
            onChange={handleChange}
            disabled={disabled}
            className="sr-only"
            {...props}
          />
          <div
            className={`
              w-4 h-4 rounded border transition-all duration-150 flex items-center justify-center
              ${activeChecked
                ? 'bg-[#8dc63f] border-[#8dc63f] text-white shadow-xs'
                : 'bg-white border-slate-300 group-hover:border-[#8dc63f]'
              }
              ${className}
            `}
          >
            {activeChecked && (
              <Check className="w-3 h-3 text-white stroke-[3.5]" />
            )}
          </div>
        </div>
        {label && (
          <span className="text-sm font-medium text-slate-700 group-hover:text-slate-900 transition-colors">
            {label}
          </span>
        )}
      </label>
    );
  }
);

Checkbox.displayName = 'Checkbox';



